export * from './QuizCompletedThankYouPage';
